<cl-sub-toolbar [currentTitle]="areaName || ' '"></cl-sub-toolbar>

<div class="cl-layout-fill scrollable">
    <loading-animation class="cl-layout-fill"
                       *ngIf="!isReady"
                       size="large"></loading-animation>

    <div *ngIf="isReady">
        <div id="cards"
             class="cl-layout-padding">
            <div *ngFor="let section of visibleSections()">
                <cas-header [primary]="areaName"
                            [contrast]="deviceModels[section].descriptor"></cas-header>
                <div class="flex-cards-wrapper">
                    <dl-card *ngFor="let control of deviceModels[section].controls"
                          [areaId]="areaId"
                          [currentControl]="control"
                          [currentRouteHardwareId]="currentHardwareId"
                          [hardwareItemId]="control.id"
                          [locationId]="locationId"
                          (onCardClicked)="setCurrentControl(section, control)"
                          [section]="deviceModels[section]"></dl-card>
                </div>
            </div>
        </div>
        <div class="cl-layout-padding"
             id="deviceSettings">
            <div ui-view></div>
        </div>
    </div>
</div>
